enum StarbucksConsumptionType {
  InStore = 'ConsumeInStore',
  OutOfStore = 'ConsumeOutOfStore',
}

export { StarbucksConsumptionType };
